import React, { ReactElement } from 'react';
import { useLocation, useParams } from 'react-router';
import { Heading, Loader } from 'idsk-react-components';
import Layout from '../Layout';
import './editPripomienkaPage.scss';
import EditPripomienka from '../../module/EditPripomienka/EditPripomienka';
import routes from '../../routing/routes';
import { usePripomienkaDetail } from '../../module/PripomienkaDetail';
import ClassType from '../../model/pripomienka/ClassType';
import { canEdit, canEditErrorConditions } from '../../function/permissions';
import { useUserContext } from '../../context/UserContext';
import ForbiddenPage from '../ForbiddenPage';
import UserRole from '../../model/currentuser/UserRole';
import SecuredPage from '../../module/SecuredPage';

export default (): ReactElement => {
  const {
    type,
    year,
    index,
    uuid,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, uuid: string }>();
  const { pathname } = useLocation();
  const {
    pripomienkaDetail,
    pripomienkaStatus,
  } = usePripomienkaDetail({ classType: ClassType.PRIPOMIENKA });
  const {
    pouzivatel,
    legislationProcess,
  } = useUserContext();

  const editForbidden: boolean = !!pripomienkaDetail && !!pouzivatel
    && !canEdit(pouzivatel, legislationProcess, pripomienkaDetail);

  return (
    <Layout
      breadcrumbRouteList={[{
        heading: routes.pripomienky.detail.name,
        to: routes.pripomienky.detail.withParams(type, year, index, uuid),
      },
      {
        heading: routes.pripomienky.edit.name,
        to: pathname,
      }]}
    >
      {editForbidden ? <ForbiddenPage /> : (
        <SecuredPage
          allowForRoles={[UserRole.PRIPOMIENKOVATEL, UserRole.NELEGISLATIVNA_ORGANIZACIA]}
          errorPageConditions={canEditErrorConditions(legislationProcess)}
          requestStatuses={[pripomienkaStatus?.responseCode]}
        >
          <>
            <Loader loading={pripomienkaStatus.loading}>
              <div className="edit-pripomienka-page">
                <Heading size="l">
                  Úprava pripomienky
                </Heading>
                <EditPripomienka
                  pripomienkaDetail={pripomienkaDetail}
                />
              </div>
            </Loader>
          </>
        </SecuredPage>
      )}
    </Layout>
  );
};
